import React, {useState} from 'react';
import {Box, Button, Checkbox, FormControlLabel, Modal, TextField, Typography} from '@mui/material';
import apiService from "../services/api";

const Welcome = ({setUser, authUser}) => {
    const [userName, setUserName] = useState('');
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [error, setError] = useState('');

    const handleNameChange = (e) => {
        setUserName(e.target.value);
    };

    const handleAgreeToTermsChange = (e) => {
        setAgreeToTerms(e.target.checked);
    };

    const handleSubmit = async () => {
        if (userName.trim().length < 2) {
            setError('שם חייב להכיל לפחות 2 אותיות.');
            return;
        }
        if (!agreeToTerms) {
            setError('עליך להסכים לתנאי השימוש כדי להמשיך.');
            return;
        }

        try {
            // Update Firebase user with the new display name
            await apiService.createUser({phoneNumber: authUser.phoneNumber, displayName: userName});
            const user = await apiService.getUser();
            setUser(user);

        } catch (error) {
            console.error('Error updating display name:', error);
            setError('שגיאה בעדכון שם.');
        }
    };

    return (
        <Modal
            open={true}
            aria-labelledby="welcome-modal-title"
            aria-describedby="welcome-modal-description"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                maxWidth: 500,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: '8px',
                direction: 'rtl',
            }}>
                <Typography variant="h4" component="h2" sx={{textAlign: 'center', mb: 2}}>
                    שלום {userName || 'אורח'}, ברוך הבא!
                </Typography>
                <Typography variant="body1" sx={{mb: 2}}>
                    אנא קח רגע לעבור על ההוראות ותנאי השימוש.
                </Typography>
                <Typography variant="body2" sx={{mb: 2}}>
                    מודל ליפשיץ AI הוא מודל בינה מלאכותית לעיבוד שפה, המבוסס על שיעורים וקורסים של אברהם
                    ליפשיץ.
                    מטרתו היא לספק ערך וייעוץ בהתאם לתורתו של אברהם ליפשיץ.
                </Typography>
                <Typography variant="body2" sx={{mb: 2}}>
                    השימוש במודל מיועד למטרות אישיות בלבד, ואנו מבקשים להימנע מאזכור שמות או פרטים אישיים של אנשים אחרים
                    במהלך השיחה.
                </Typography>
                <Typography variant="body2" sx={{mb: 2}}>
                    כל מידע שתספק במהלך השיחה יישמר באופן מאובטח, ולא יינתן לאף אחד אחר ללא הסכמתך.
                </Typography>
                <Typography variant="body2" sx={{mb: 2}}>
                    חשוב לציין שמודל זה עדיין נמצא בשלב ניסיוני. אם תרגיש שהמודל ייעץ או דיבר בצורה שאינה הולמת, אנא צור
                    איתנו קשר כדי שנוכל לטפל בכך בהקדם.
                </Typography>
                <TextField
                    label="הזן את שמך"
                    value={userName}
                    onChange={handleNameChange}
                    fullWidth
                    margin="normal"
                    sx={{mb: 2}}
                />
                <FormControlLabel
                    control={<Checkbox checked={agreeToTerms} onChange={handleAgreeToTermsChange}/>}
                    label="אני מסכים לתנאי השימוש"
                    sx={{mb: 2}}
                />
                {error && <Typography color="error" sx={{mb: 2}}>{error}</Typography>}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    fullWidth
                >
                    אם הכל ברור והנך מסכים לתנאי השימוש לחץ כאן
                </Button>
            </Box>
        </Modal>
    );
};

export default Welcome;
